import { Component } from '@angular/core';

interface WhatWeDoSection {
  titleKey: string;
  emailKey: string;
  listKey: string;
  photo: string;
  photoAltKey: string;
  badge: string;
}

const IMAGES = 'assets/images/what-we-do';

@Component({
  selector: 'what-we-do-smart-response',
  templateUrl: './smart-response.component.html',
  styleUrls: ['./smart-response.component.css'],
})
export class SmartResponseComponent {
  sections: WhatWeDoSection[] = [
    {
      titleKey: 'WHAT-WE-DO_DONORS-TITLE',
      emailKey: 'WHAT-WE-DO_DONORS-EMAIL',
      listKey: 'WHAT-WE-DO_DONORS-LIST',
      photo: `${IMAGES}/photo-donors.jpg`,
      photoAltKey: 'WHAT-WE-DO_DONORS-PHOTO-ALT',
      badge: `${IMAGES}/badge-donors.svg`,
    },
    {
      titleKey: 'WHAT-WE-DO_NGOS-TITLE',
      emailKey: 'WHAT-WE-DO_NGOS-EMAIL',
      listKey: 'WHAT-WE-DO_NGOS-LIST',
      photo: `${IMAGES}/photo-ngos.jpg`,
      photoAltKey: 'WHAT-WE-DO_NGOS-PHOTO-ALT',
      badge: `${IMAGES}/badge-ngos.svg`,
    },
    {
      titleKey: 'WHAT-WE-DO_JOURNALISTS-TITLE',
      emailKey: 'WHAT-WE-DO_JOURNALISTS-EMAIL',
      listKey: 'WHAT-WE-DO_JOURNALISTS-LIST',
      photo: `${IMAGES}/photo-journalists.jpg`,
      photoAltKey: 'WHAT-WE-DO_JOURNALISTS-PHOTO-ALT',
      badge: `${IMAGES}/badge-journalists.svg`,
    },
  ];
}
